<template>
	<div>
		<template v-for="(project, index) in projects">
			<div v-if="project.qStatus != '1'" :key="index">

				<div v-if="isProfileProject(project.custom_attributes) === true" class="box orange survey flex">
					<span class="icon warpit_icon_survey"></span>
					<div class="boxContent" style="width: 100%">
						<span class="boxTitle">
							<span class="bold">{{ $t("dashboard.profile")}}</span>
							{{ $t("dashboard.profile_text_1")}}
						</span>
						<a class="boxesLink" target="_blank" v-bind:href="project.url">
							<div class="card">
								<h3>{{ $t("dashboard.profile_text_2") }}</h3>
								<h2>
									<span>{{ getProjectName(project) }}</span>
								</h2>
								<hr v-if="project.progress !== 0" class="grey" />
								<span v-if="project.progress !== 0" class="fullfiled">Izpolnili ste {{project.progress}} % te ankete.</span>
								<div class="visual"></div>
								<hr v-if="project.progress !== 0" class="grey" />
								<div v-if="project.progress !== 0" class="progress-bar linear" data-percentage="project.progress">
									<span class="transition" v-bind:style="{width:project.progress+'%'}"></span>
								</div>
								<hr class="grey" />
								<ul>
									<li v-if="project.max_points > 0" class="flex">
										<span class="icon warpit_icon_loyalty-point"></span>
										<span>{{ formatNumber(project.max_points) }} {{ $t("dashboard.notes") }}</span>
									</li>
									<li class="flex">
										<span class="icon warpit_icon_clock"></span>
										<span>{{ getDuration(project.custom_attributes) }} {{ $t("dashboard.min") }}</span>
									</li>
								</ul>
								<div class="categoryIcon">
									<img :src="selectSurveyIcon(project.project_name)" />
								</div>
							</div>
						</a>
					</div>
				</div>
				<div v-else-if="isUsePointsProject(project.custom_attributes) === true && getAvailablePoints(points.transactions) > 999" class="box blue survey flex">
					<span class="icon warpit_icon_survey"></span>
					<div class="boxContent" style="width: 100%">
						<span class="boxTitle">
							<span class="bold">{{ $t("dashboard.usePointsTitle") }}</span>
						</span>
						<a class="boxesLink" target="_blank" v-bind:href="project.url">
							<div class="card">
								<h3>{{ $t("dashboard.usePoints") }}</h3>
								<h2>
									<span>{{ getProjectName(project) }}</span>
								</h2>
								<hr class="grey" />
								<p>
									{{ $t("dashboard.usePointsDescription") }}
								</p>
								<div class="categoryIcon">
									<img src="@/assets/images/gift.svg" />
								</div>
							</div>
						</a>
					</div>
				</div>
				<div v-else-if="isUsePointsProject(project.custom_attributes) === false" class="box pink survey flex">
					<span class="icon warpit_icon_survey"></span>
					<div class="boxContent" style="width: 100%">
						<span v-if="isTicketExist(project.custom_attributes) === false" class="boxTitle">
							<span class="bold">{{ $t("dashboard.normal") }}</span>
							{{ $t("dashboard.normal_text_1") }} {{ formatNumber(project.max_points) }}  {{ $t("dashboard.notes") }}
						</span>
						<span v-else class="boxTitle">
							<span class="bold">Nova tematska anketa za vas!</span>
							{{ $t("dashboard.normal_text_1") }} {{ formatNumber(project.max_points) }}  {{ $t("dashboard.normal_text_2") }}
						</span>
						<a class="boxesLink" target="_blank" v-bind:href="project.url">
							<div class="card">
								<h3>Tematska anketa</h3>
								<h2>
									<span>{{ getProjectName(project) }}</span>
								</h2>
								<hr v-if="project.progress !== 0" class="grey" />
								<span v-if="project.progress !== 0" class="fullfiled">Izpolnili ste {{project.progress}} % te ankete.</span>
								<div class="visual"></div>
								<hr v-if="project.progress !== 0" class="grey" />
								<div v-if="project.progress !== 0" class="progress-bar linear" data-percentage="project.progress">
									<span class="transition" v-bind:style="{width:project.progress+'%'}"></span>
								</div>
								<hr class="grey" />
								<ul>
									<li v-if="project.max_points > 0" class="flex">
										<span class="icon warpit_icon_loyalty-point"></span>
										<span>{{ formatNumber(project.max_points) }}  točk</span>
									</li>
									<li class="flex">
										<span class="icon warpit_icon_clock"></span>
										<span>{{ getDuration(project.custom_attributes) }} {{ $t("dashboard.min") }}</span>
									</li>
								</ul>
								<div class="categoryIcon">
									<img src="@/assets/images/survey.svg" />
								</div>
							</div>
						</a>
					</div>
				</div>

			</div>
		</template>
	</div>
</template>

<script>
import { calculateDiffDays, formatNumber, selectSurveyIcon, getAvailablePoints } from "@/helpers";

export default {
	name: "project",
	update(){
		this.points();
	},
	computed: {
		projects() {
			return this.$store.getters["user/projects"];
		},
		points() {
			return this.$store.getters["user/points"]
		},
	},
	mounted() {},
	methods: {
		calculateDiffDays,
		formatNumber,
		selectSurveyIcon,
		getAvailablePoints,
		isProfileProject(custom_attributes) {
			let custom_attribute = custom_attributes.find(
				(element) => element.name == "type"
			);

			if (custom_attribute !== undefined && custom_attribute.value == "profile") {
				return true;
			}
			return false;
		},
		isUsePointsProject(custom_attributes) {
			let custom_attribute = custom_attributes.find(
				(element) => element.name == "type"
			);

			if (custom_attribute !== undefined && custom_attribute.value == "usepoints") {
				return true;
			}
			return false;
		},
		getDuration(custom_attributes) {
			let custom_attribute = custom_attributes.find(
				(element) => element.name == "duration"
			);

			return custom_attribute === undefined ? "15" : custom_attribute.value;
		},
		isTicketExist(custom_attributes) {
			let custom_attribute = custom_attributes.find(
				(element) => element.name == "ticket"
			);

			if (custom_attribute !== undefined && custom_attribute.value == "1") {
				return true;
			}

			return false;
		},
		getProjectName(project){
			if (project.long_project_name) {
				return project.long_project_name ; 
			}
			return project.project_name;
		}
	},
};
</script>
